import { useQuery } from '@tanstack/react-query';
import { fetchShowPeriodSummaries, showPeriodSummaryQueryKey, type EventShowPeriodSummary } from '../data/showPeriodSummary';

/** Compact header reads are bounded even in grouped and calendar views. */
export function useShowPeriodSummaries(eventIds: string[]) {
  const ids = [...new Set(eventIds)].sort();
  return useQuery({ queryKey: showPeriodSummaryQueryKey(ids), enabled: ids.length > 0, staleTime: 30_000,
    queryFn: async () => {
      const result: Record<string, EventShowPeriodSummary> = {};
      for (let start = 0; start < ids.length; start += 100) {
        Object.assign(result, await fetchShowPeriodSummaries(ids.slice(start, start + 100)));
      }
      return result;
    } });
}
